import React, { FormEvent, useMemo, useState } from 'react'
import { exportHandler } from '../../../helpers'
import DetailModalWrapper from '../../../components/DetailModalWrapper'
import { ReactComponent as DocIcon } from '../../../assets/icons/doc.svg'
import s from './index.module.scss'
import { useEditRefuellingMutation, useGetRefuellingByIdQuery } from '../../../store/refuellings/refuellings.api'
import Table from '../../../components/Table'
import { refuellingsInfoColumns } from '../../../constants/refuellingsPage'
import Input from '../../../components/UI/Input'
import Button from '../../../components/UI/Button'
import { useAppSelector } from '../../../hooks/useAppSelector'

const RefuellingForm = ({ id, number }: { id: string | number; number: string }) => {
	const [edit, { isLoading, error }] = useEditRefuellingMutation()

	const [value, setValue] = useState<string>(number)
	const [isSaved, setIsSaved] = useState<boolean>(false)

	const submitHandler = (ev: FormEvent) => {
		ev.preventDefault()

		edit({ id, value: Number(value) })
			.unwrap()
			.then((res) => {
				if (res.status === 'success') {
					setIsSaved(true)
					setTimeout(() => {
						setIsSaved(false)
					}, 3000)
				}
			})
	}

	return (
		<form className={s.form} onSubmit={submitHandler}>
			<Input
				value={value}
				onChange={(ev: React.ChangeEvent<HTMLInputElement>) => setValue(ev.target.value)}
				label={'Номер акцизної накладної'}
				placeholder={'Номер акцизної накладної'}
				required
			/>

			{error && 'data' in error && <p className={s.error}>{error?.data?.message}</p>}

			<Button variant="filled" disabled={!value || isLoading} type="submit" className={s.btn}>
				{isSaved ? 'Збережено' : 'Зберегти'}
			</Button>
		</form>
	)
}

interface IProps {
	id: string | number
	closeHandler: () => void
}

const RefuellingsDetailModal: React.FC<IProps> = ({ id, closeHandler }) => {
	const { permissions } = useAppSelector((state) => state.common)

	const { data, isLoading } = useGetRefuellingByIdQuery({ id })

	const tableData = useMemo(() => [data], [data])

	const [error, setError] = useState<string>('')

	const downloadPdf = async (url: string, title: string) => {
		try {
			await exportHandler(url, title, 'pdf', true)
		} catch (err) {
			if (err instanceof Error) {
				setError(err?.message)
			}
		}
	}

	return (
		<DetailModalWrapper isLoading={isLoading} closeHandler={closeHandler}>
			<div className={s.titleWrapper}>
				<div className={s.docsWrapper}>
					<div className={s.docsIcon}>
						<DocIcon />
					</div>
					<div className={s.docsList}>
						<div onClick={() => downloadPdf(`refuellings/${id}/documents/excise-invoice?pdfMode=3`, 'Акцизна накладна')}>Акцизна накладна</div>
						<div onClick={() => downloadPdf(`refuellings/${id}/documents/ttn?pdfMode=3`, 'ТТН')}>ТТН</div>
					</div>
				</div>
				<h2 className={s.title}>Переміщення №{id}</h2>
			</div>

			{error && <p className={s.error}>{error}</p>}

			<DetailModalWrapper.Title>Інформація про переміщення</DetailModalWrapper.Title>
			<Table data={tableData} columns={refuellingsInfoColumns} maxHeight={'200px'} />

			{permissions.includes('REFUELLINGS_UPDATE') && <RefuellingForm id={id} number={data?.exciseInvoiceNumber?.toString() || ''} />}
		</DetailModalWrapper>
	)
}

export default RefuellingsDetailModal
